var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paddingBox" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rounded-box --whiteBg p-50" },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("aside", { staticClass: "kolektiv-meta mb-20" }, [
          _c("p", { staticClass: "koletiv-name mb-0" }, [
            _c("b", { staticClass: "text-dark" }, [
              _vm._v(_vm._s(_vm.form.pouzivatel_name))
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "kolektiv-email mb-0" }, [
            _vm._v(_vm._s(_vm.form.pouzivatel_email))
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "kolektiv-password" },
            [
              _vm.showPassword
                ? [_vm._v(_vm._s(_vm.form.pouzivatel_password))]
                : _vm._l(_vm.form.pouzivatel_password.length, function(index) {
                    return [_vm._v("*")]
                  }),
              _vm._v(" "),
              _c("span", {
                staticClass: "icon icon--eye text-icon ml-10 cursor-pointer",
                on: {
                  click: function($event) {
                    _vm.showPassword = !_vm.showPassword
                  }
                }
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "kolektiv-info mb-50" }, [
          _c("tr", [
            _c("th", { attrs: { width: "145" } }, [_vm._v("Typ kolektívu")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(_vm.form.pouzivatel_rocnik === 0 ? "Škôlka" : "Škola")
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { width: "145" } }, [_vm._v("Škola")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.form.pouzivatel_skola.cely_nazov))])
          ]),
          _vm._v(" "),
          _vm.form.pouzivatel_rocnik
            ? _c("tr", [
                _c("th", { attrs: { width: "145" } }, [_vm._v("Ročník")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.form.pouzivatel_rocnik))])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-uppercase mb-20" }, [
          _c("b", { staticClass: "text-dark" }, [
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(_vm._s(_vm.form.pouzivatel_ziaci.length))
            ]),
            _vm._v(" pridaných žiakov")
          ])
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "ziaci" },
          _vm._l(_vm.form.pouzivatel_ziaci, function(ziak, index) {
            return _c("li", { key: index }, [
              _c("span", { staticClass: "icon icon--user mr-10 text-icon" }),
              _vm._v(_vm._s(ziak) + "\n                ")
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("validation-observer", {
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function(ref) {
                  var handleSubmit = ref.handleSubmit
                  return [
                    _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return handleSubmit(_vm.submit)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "separator" })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: { required: { allowFalse: false } },
                                  name: "Súhlas s pravidlami súťaže"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var valid = ref.valid
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "custom-control custom-checkbox mb-2",
                                              class: {
                                                "is-error": errors.length
                                              }
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.form
                                                        .pouzivatel_suhlas_pravidla_pouzivania,
                                                    expression:
                                                      "form.pouzivatel_suhlas_pravidla_pouzivania"
                                                  }
                                                ],
                                                staticClass:
                                                  "custom-control-input",
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "customCheck1-kolektiv"
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.form
                                                      .pouzivatel_suhlas_pravidla_pouzivania
                                                  )
                                                    ? _vm._i(
                                                        _vm.form
                                                          .pouzivatel_suhlas_pravidla_pouzivania,
                                                        null
                                                      ) > -1
                                                    : _vm.form
                                                        .pouzivatel_suhlas_pravidla_pouzivania
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.form
                                                          .pouzivatel_suhlas_pravidla_pouzivania,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.form,
                                                            "pouzivatel_suhlas_pravidla_pouzivania",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.form,
                                                            "pouzivatel_suhlas_pravidla_pouzivania",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "pouzivatel_suhlas_pravidla_pouzivania",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "custom-control-label",
                                                  attrs: {
                                                    for: "customCheck1-kolektiv"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Mám záujem o registráciu na stránke adoptujkravicku.sk a o účasť v súťaži, ktorej organizácia sa spravuje\n                                    "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        target: "_blank",
                                                        href:
                                                          "https://www.adoptujkravicku.sk/engine/wp-content/uploads/2017/08/Adoptujkravicku-pravidla-sutaze-REV19082021.pdf"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Pravidlami súťaže"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    ".*\n                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _vm._v(" "),
                              _c("validation-provider", {
                                attrs: {
                                  rules: { required: { allowFalse: false } },
                                  name: "Súhlas so spracúvaním osobných údajov"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var valid = ref.valid
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "custom-control custom-checkbox mb-2",
                                              class: {
                                                "is-error": errors.length
                                              }
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.form
                                                        .pouzivatel_suhlas_osobne_udaje,
                                                    expression:
                                                      "form.pouzivatel_suhlas_osobne_udaje"
                                                  }
                                                ],
                                                staticClass:
                                                  "custom-control-input",
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "customCheck2-kolektiv"
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.form
                                                      .pouzivatel_suhlas_osobne_udaje
                                                  )
                                                    ? _vm._i(
                                                        _vm.form
                                                          .pouzivatel_suhlas_osobne_udaje,
                                                        null
                                                      ) > -1
                                                    : _vm.form
                                                        .pouzivatel_suhlas_osobne_udaje
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.form
                                                          .pouzivatel_suhlas_osobne_udaje,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.form,
                                                            "pouzivatel_suhlas_osobne_udaje",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.form,
                                                            "pouzivatel_suhlas_osobne_udaje",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "pouzivatel_suhlas_osobne_udaje",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "custom-control-label",
                                                  attrs: {
                                                    for: "customCheck2-kolektiv"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Súhlasím so spracúvaním mojich osobných údajov za podmienok uvedených v\n                                    "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        target: "_blank",
                                                        href:
                                                          "https://www.adoptujkravicku.sk/pravidla-ochrany-osobnych-udajov/"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Pravidlách ochrany osobných údajov"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                                    spojených s prevádzkou webovej stránky adoptujkravičku.sk.*\n                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "custom-control custom-checkbox"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.form.pouzivatel_suhlas_marketing,
                                        expression:
                                          "form.pouzivatel_suhlas_marketing"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "checkbox",
                                      id: "customCheck3-kolektiv"
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.form.pouzivatel_suhlas_marketing
                                      )
                                        ? _vm._i(
                                            _vm.form
                                              .pouzivatel_suhlas_marketing,
                                            null
                                          ) > -1
                                        : _vm.form.pouzivatel_suhlas_marketing
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a =
                                            _vm.form
                                              .pouzivatel_suhlas_marketing,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.form,
                                                "pouzivatel_suhlas_marketing",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.form,
                                                "pouzivatel_suhlas_marketing",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.form,
                                            "pouzivatel_suhlas_marketing",
                                            $$c
                                          )
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "customCheck3-kolektiv" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                Súhlasím so zasielaním marketingových informácií o slovenskom mlieku a mliečnych výrobkoch rôznych slovenských výrobcov na môj e-mail za podmienok uvedených v\n                                "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href:
                                              "https://www.adoptujkravicku.sk/pravidla-ochrany-osobnych-udajov/"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Pravidlách ochrany osobných údajov"
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                spojených s prevádzkou webovej stránky adoptujkravičku.sk.\n                            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("div", { staticClass: "separator" })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._t("error-message"),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row mb-0" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-12 text-right" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-primary text-underline cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "updateStep",
                                            "zoznam"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Späť na zoznam žiakov")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn --primary",
                                      attrs: { type: "submit" }
                                    },
                                    [_vm._v("odoslať registráciu")]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ],
                      2
                    )
                  ]
                }
              }
            ],
            null,
            true
          )
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "d-flex align-items-center justify-content-between mb-20"
      },
      [_c("h2", { staticClass: "mb-0" }, [_vm._v("Zhrnutie registrácie")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-uppercase mb-20" }, [
      _c("b", { staticClass: "text-dark" }, [_vm._v("Informácie o kolektíve")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }